import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import * as types from 'constants/actionTypes';
import { DialogActions, DialogContent } from '@mui/material';
import { Button } from '@mui/material'

class DialogAlert extends Component {
    constructor(props) {
        super(props);
        if (props.message) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, open: props.open, message: props.message };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, open: false, message: "" };
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.open && newProps.open !== this.state.open)
            && (newProps.message && newProps.message !== this.state.message))//if store's value relative to this component change, update the state value
            this.setState({ open: newProps.open, message: newProps.message });
        else if (!newProps.open)//in case the store does not have any value for this component, just clear it
            this.setState({ open: false, message: '' });
    }

    handleClose = () => {
        this.setState({ open: false });
        this.props.dialogAlertClose();
        if (this.props.onDialogClosed) {
            this.props.onDialogClosed();
        }
        if (this.props.onClose && typeof this.props.onClose === 'function') {
            this.props.onClose();
        }
    };

    render() {
        return (
            <React.Fragment>
                <Dialog
                    open={this.state.open}
                    sx={{
                        zIndex: '99999', '& .MuiDialog-paper': {
                            width: "50%"
                        },
                    }}
                    onClose={this.handleClose}
                >
                    <DialogContent >
                        {this.state.message}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        open: state.common[(ownProps.name ? ownProps.name : "dialog") + "Alert"] ? state.common[(ownProps.name ? ownProps.name : "dialog") + "Alert"].open : false,
        onClose: state.common[(ownProps.name ? ownProps.name : "dialog") + "Alert"] ? state.common[(ownProps.name ? ownProps.name : "dialog") + "Alert"].onClose : null,
        message: state.common[(ownProps.name ? ownProps.name : "dialog") + "Alert"] ? state.common[(ownProps.name ? ownProps.name : "dialog") + "Alert"].message : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dialogAlertClose: () => dispatch({ type: types.DIALOG_ALERT_CLOSE })
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogAlert);